import { AxiosRequestConfig } from "axios";
import ApiBase from "../apiRequestBase";
import { PicturePresignedUrlRequest } from "../../models/communityTalk/picture/picturePresignedUrlRequest";
import { PictureCompleteRequest } from "@/apiRequests/models/communityTalk/picture/pictureCompleteRequest";
import { PictureCompleteResponse } from "@/apiRequests/models/communityTalk/picture/pictureCompleteResponse";

/**
 * 画像投稿系API。
 */
export default class PictureApiRequest {
	/**
	 * 署名付きURL取得APIのPOSTリクエスト
	 */
	public async getPresignedUrl(tenantId: string): Promise<PicturePresignedUrlRequest> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/picture/presigned_url`,
			method: "GET",
			headers: {
				tenantId: tenantId,
			},
		};
		return (await ApiBase.requestWithApiToken<PicturePresignedUrlRequest>(tenantId, options)) as PicturePresignedUrlRequest;
	}

	/**
	 * 画像変換APIのPOSTリクエスト
	 */
	public async complete(tenantId: string, request: PictureCompleteRequest): Promise<PictureCompleteResponse> {
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/picture/complete`,
			headers: {
				tenantId: tenantId,
				"Content-Type": "application/json",
			},
			data: request,
			method: "POST",
		};
		try {
			return (await ApiBase.requestWithApiToken<PictureCompleteResponse>(tenantId, options)) as PictureCompleteResponse;
		} catch {
			// 画像変換処理APIは失敗してもリトライしたいため、エラー時でも例外を投げない
			throw new Error("画像変換処理APIのリクエストに失敗しました。");
		}
	}
}
